module.exports = __webpack_public_path__ + "image/registration_banner.jpg";